/** @format */

export function getField(id, field) {
  try {
    return this.getUser(id)[field];
  } catch (error) {
    return null;
  }
}
